import Cookie from './Cookie.js';

class ModalPopup {
	constructor(config) {
		this.config = Object.assign({
			scope: '#pagePopup',
            close: '[data-bs-dismiss="modal"]',
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.modal = new bootstrap.Modal(this.config.scope);
		this.cookie = new Cookie('pop-up-seen');
        if (this.cookie.get() !== 'true') {
            this.initEventListeners();
            if (this.isTouchDevice()) {
                setTimeout(() => this.showModal(), 10000);
            }
        }
	}

    initEventListeners() {
        $(document).on('mouseleave', () => this.showModal());
        $(this.config.close).on('click', () => this.disposeModal());
        this.$scope.find('form').on('submit', (event) => this.disposeSubmit(event));
    }

    showModal() {
        if (this.cookie.get() !== 'true') {
            this.modal.show();
        }
    }

    disposeModal() {
        this.modal.hide();
        this.cookie.set(true);
    }

    disposeSubmit(event) {
        let error = $(event.currentTarget).find('.error');
        if (error.length <= 0) {
            this.cookie.set(true);
        }
    }

    isTouchDevice() {
        return (('ontouchstart' in window) ||
            (navigator.maxTouchPoints > 0) ||
            (navigator.msMaxTouchPoints > 0));
    }
}

export default new ModalPopup;
